import { Injectable } from '@angular/core';
import { HttpEvent, HttpInterceptor, HttpHandler, HttpRequest } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { AuthService } from '../services/auth.service';
import { environment } from 'src/environments/environment';
import { catchError, switchMap } from 'rxjs/operators';
import {API_TYPE, HttpHelperService} from "./http-helper.service";
import {ArticleService} from "../modules/account/services/article.service";
import {BORI_BBL_COMP_ID} from "../modules/account/services/member.service";

/** Pass untouched request through to the next request handler. */
@Injectable()
export class HttpHeaderInterceptor implements HttpInterceptor {

    constructor(private authService: AuthService, private httpHelper: HttpHelperService, private  articleService: ArticleService) {
    }

    intercept(req: HttpRequest<any>, next: HttpHandler):
        Observable<HttpEvent<any>> {
      // EXCEPTIONAL CONDITION FOR VERIFY APP API CALLS
      let isVerifyAppAPI = true;
      if(req.url.includes(environment.apiBaseUrl)){
        isVerifyAppAPI = false;
      }
      const apiType = this.httpHelper.getApiTypeFromUrl(req.url);
        return this.authService.checkAndAquireToken().pipe(
            switchMap((response: any) => {
                const newHeaderUpdate = this.updateAuthHeader(req, response.accessToken, isVerifyAppAPI, apiType);
                return next.handle(req.clone(newHeaderUpdate));
            }),
            catchError(err => {
                const errStr = err.toString();
                if (err.name === "InteractionRequiredAuthError") {
                    return this.authService.logoutUser();
                }
                // interaction_in_progress after B2C must not log the member out;
                // that left the landing spinner up and sent them around again.
                if (err.name === "BrowserAuthError" && !errStr.includes('interaction_in_progress')) {
                    return this.authService.logoutUser();
                }
                if(err.name == 'ServerError' && errStr.includes('redirect_uri_mismatch')){
                    return this.authService.logoutUser();
                }
                return throwError(err);
            }));
    }

    // This method add token to request headers
    updateAuthHeader(req: HttpRequest<any>, access_token?: string, isVerifyAppAPi?: boolean, apiType?: any): any {
        // Update headers with access token

        const headerObj: any = {};
        const apiTypesWithCompanyId = [API_TYPE.ARTICLE_API, API_TYPE.MEMBER_API, API_TYPE.CRM_MANAGER_API];
        const apiTypesWithoutSubscription = [API_TYPE.USERMANAGER_API, API_TYPE.OWNERSHIP_API, API_TYPE.CRM_MANAGER_API];

        let compId =   this.articleService.getCompanyForAPIHeader();
        // if(!compId && apiType == API_TYPE.MEMBER_API){
        //   compId = BORI_BBL_COMP_ID;
        // }
        if(!compId && apiTypesWithCompanyId.includes(apiType) ){
          compId = BORI_BBL_COMP_ID;
        }
        if (apiTypesWithCompanyId.includes(apiType)){
          const companyIdFromRequest = req.headers.get('companyId');
          headerObj['companyId'] = (companyIdFromRequest != null && companyIdFromRequest.trim() !== '')
            ? companyIdFromRequest
            : compId;
        }else if(!apiTypesWithoutSubscription.includes(apiType)){

          if (apiType == API_TYPE.SIGNUP_API){
            headerObj['subscription-key'] = environment.signupApp_subscriptionKey;
          }else if(isVerifyAppAPi){
            headerObj['subscription-key'] = environment.verifyApp_subscriptionKey;
          }else{
            headerObj['subscription-key'] = environment.subscriptionKey;
          }
        }

        if(access_token){
          headerObj['Authorization'] = 'Bearer ' + access_token;
        }
        const newHeaderUpdate = {
          setHeaders: headerObj
        };
        return newHeaderUpdate;
    }
}
